import { useLang } from '../context/LangContext';

export default function LanguageSwitcher() {
  const { lang, setLang } = useLang();

  const styles = {
    container: {
      display: 'flex',
      gap: '4px',
      alignItems: 'center'
    },
    flag: {
      fontSize: '24px',
      cursor: 'pointer',
      transition: 'opacity 0.2s',
      userSelect: 'none'
    },
    active: {
      opacity: 1
    },
    inactive: {
      opacity: 0.3,
      filter: 'grayscale(100%)'
    }
  };

  return (
    <div style={styles.container}>
      <span 
        onClick={() => setLang('fr')}
        style={{
          ...styles.flag,
          ...(lang === 'fr' ? styles.active : styles.inactive)
        }}
        title="Français"
      >
        🇫🇷
      </span>
      <span 
        onClick={() => setLang('en')}
        style={{
          ...styles.flag,
          ...(lang === 'en' ? styles.active : styles.inactive)
        }}
        title="English"
      >
        🇬🇧
      </span>
    </div>
  );
}
